import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthProvider } from '../auth';
import GlobalAIReportProgressBanner from '../views/Quantum/GlobalAIReportProgressBanner';



import MainLayout from '../MainLayout/MainLayout';
import NotFound from '../components/NotFound/NotFound';
import Home from '../views/Home/home';
import Skincare from '../views/SkinCare/SkinCare';
import CosmeticSkinCareLanding from '../views/SkinCare/CosmeticSkinCareLanding';
import CosmeticFaceCapture from '../views/SkinCare/CosmeticFaceCapture';
import CosmeticDetails from '../views/SkinCare/CosmeticDetails';
import CosmeticAnalysis from '../views/SkinCare/CosmeticAnalysis';
import CosmeticResults from '../views/SkinCare/CosmeticResults';
import CosmeticPreviousReports from '../views/SkinCare/CosmeticPreviousReports';
import VisionCareMain from '../views/VisionCare/VisionCareMain';
import LungsCare from '../views/LungsCare/LungsCare';
import AiDiet from '../views/AiDiet/AiDietLanding';
import DietRecommender from '../views/AiDiet/Recommend';
import DietResults from '../views/AiDiet/Results'
import OldDietHistory from '../views/AiDiet/Olddiet'
// import OralCare from '../components/OralCare/OralCare';
import OralCare from '../views/OralCare/OralCare';
import SymptomCheckerChat from '../views/SymptomChecker/SymptomCheckerChat'
import SymptomcheckerAnalyze from "../views/SymptomChecker/SymptomChecker";
// import SmartReport from "../components/smartReport/smartReportLanding";
import SmartReport from "../views/SmartReport/SmartReport";
import Caresathi from "../views/Caresathi/Caresathi";
import AskCaresathi from "../components/CareSathi/Newcaresathi";
// import Labinsight from '../components/LabInsight/LabInsightsMain';
import LabInsightsMain from '../views/LabInsights/LabInsightsMain';
import Thankyoupagedcs from '../components/DCS/Thankyoupagedcs';
import MedicineOrderPlaced from '../components/DCS/MedicineOrderPlaced';
import SubscriptionPayU from '../components/DCS/SubscriptionPayU';
import LoginPage from '../components/Login/Login';
import ForgotPasswordReset from '../components/Login/ForgotPaaswordReset';
import AiReports from '../views/postlogin/AiReports';
import MySmartDiets from '../views/postlogin/MySmartDiets';
import SmartReportLabList from '../views/postlogin/SmartReportLabList';
import SmartVitalsDetails from '../views/SmartVitals/SmartVitalsLanding';
import SmartVitalsInstruct from '../views/SmartVitals/SmartVitalsInstruct';
import SmartVitalsReport from '../views/SmartVitals/SmartVitalsReport';
import SmartVitalsChecker from "../views/SmartVitals/SmartVitalsChecker";
import DocumentsSection from '../views/postlogin/DocumentsSection';
import MySubscription from '../views/postlogin/MySubscription';
import MyLabReports from '../views/postlogin/MyLabReports';
import TermsOfUse from '../views/Legal/TermsOfUse';
import PrivacyPolicy from '../views/Legal/PrivacyPolicy';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

const AppRoutes = () => (
  <AuthProvider>
  <Router>
    <ScrollToTop />
    <GlobalAIReportProgressBanner />
    <MainLayout>
       
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
          <Route path="/skincare" element={<Skincare />} />
          <Route path="/cosmetic-skincare-analysis" element={<CosmeticSkinCareLanding />} />
          <Route path="/cosmetic-skincare-analysis/face-scan" element={<CosmeticFaceCapture />} />
          <Route path="/cosmetic-skincare-analysis/details" element={<CosmeticDetails />} />
          <Route path="/cosmetic-skincare-analysis/analysis" element={<CosmeticAnalysis />} />
          <Route path="/cosmetic-skincare-analysis/results" element={<CosmeticResults />} />
          <Route path="/cosmetic-skincare-analysis/reports" element={<CosmeticPreviousReports />} />
          <Route path="/lungscare" element={<LungsCare/>} /> 
          <Route path="/visioncare" element={<VisionCareMain/>} />
          <Route path="/smartreportlist" element={<SmartReportLabList />} />
          <Route path="/smartdiet" element={<AiDiet/>} /> 
          <Route path="/my-smart-diets" element={<MySmartDiets />} />
          <Route path="/smartdiet/generate" element={<DietRecommender/>} /> 
          <Route path="/result" element={<DietResults/>} /> 
          <Route path="/smartdiet-report" element={<OldDietHistory/>} />
          <Route path="/documents" element={<DocumentsSection />} />
          <Route path="/my-subscription" element={<MySubscription />} />
          <Route path="/mylabreports" element={<MyLabReports />} />
                    <Route path="/oralcare" element={<OralCare />} /> 
                      <Route path="/smartvital" element={<SmartVitalsDetails />} /> 
                       <Route path="/smart-vital-instr" element={<SmartVitalsInstruct />} />
        <Route path="/smart-vital-report" element={<SmartVitalsReport />} /> 
        <Route path="/smart-vital-checker" element={<SmartVitalsChecker />} /> 
         <Route path="/symptomchecker/chat" element={<SymptomCheckerChat />} />
          <Route path="/symptomchecker" element={<SymptomcheckerAnalyze />} /> 
            <Route path="/smartreport" element={<SmartReport />} /> 
             <Route path="/caresathi" element={<Caresathi />} /> 
             <Route path="/aireports" element={<AiReports />} /> 
                          <Route path="/ask-caresathi" element={<AskCaresathi />} /> 
                           <Route path="/subscription-payment" element={<SubscriptionPayU />} />
                         <Route path="/thankyoucaresathi" element={<Thankyoupagedcs />} />
                         <Route path="/subscription/thank-you" element={<Thankyoupagedcs />} />
                       <Route path="/forgot-password-reset" element={<ForgotPasswordReset />} />
                              <Route path="/LabInsights" element={< LabInsightsMain/>} /> 
          <Route path="/medicine_orderplace" element={<MedicineOrderPlaced />} />
          <Route path="/terms-conditions" element={<TermsOfUse />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </MainLayout>
  </Router>
  </AuthProvider>
);

export default AppRoutes;
